import React, { useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiPacks } from "~/routes"

import PageContainer from "~/library/PageContainer"
import PackForm from "~/components/PackForm"
import LoadingWrapper from "~/library/LoadingWrapper"
import Pack from "~/types/Pack"

const EditPack = () => {
  const [isPackUpdated, setIsPackUpdated] = useState<boolean>(false)

  const { id } = useParams<{ id: string }>()
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const endpoint = apiPacks.show.path({ venueSlug, id: id! })
  const { data: pack, isLoading } = useFetchResource<{ pack: Pack }, "pack">(endpoint, "pack", {})

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      id: id!,
      pack: formValues,
    }

    apiPacks
      .update({ data })
      .then(() => {
        setIsPackUpdated(true)
        toast("Pack updated successfully", "success")
      })
      .catch((res) => {
        toast(
          `Error updating pack. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  if (isPackUpdated) {
    return <Navigate to={`/packs/${id}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Pack</h3>
          <LoadingWrapper isLoading={isLoading}>
            <PackForm onSubmit={handleSubmit} initialValues={pack} isEditing={true} />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default EditPack
